import { useEffect, useState } from 'react';

export function useMemory() {
  const [memoryInfo, setMemoryInfo] = useState({
    totalJSHeapSize: 0,
    usedJSHeapSize: 0,
    jsHeapSizeLimit: 0,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      if ((performance as any).memory) {
        setMemoryInfo({
          totalJSHeapSize: (performance as any).memory.totalJSHeapSize,
          usedJSHeapSize: (performance as any).memory.usedJSHeapSize,
          jsHeapSizeLimit: (performance as any).memory.jsHeapSizeLimit,
        });
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return memoryInfo;
}
